import TagImage from './TagImage'

export type { TagImageProps } from './TagImage.types'

export default TagImage
